import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { BaseComponent } from "../../../base.component";
import {
  Form,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { AlertService } from "../../../_services/alert.service";
import { DataService } from "../../../_services/data.service";

@Component({
  moduleId: module.id,
  selector: "collective",
  templateUrl: "collective-receipt.component.html",
  styleUrls: ["./collective-receipt.component.css"],
})
export class CollectiveReceiptComponent extends BaseComponent {
  @Input() events: any;
  modalReference: any;
  selectedEvent: any;
  formGroup: FormGroup;
  successMessage: string;

  constructor(
    public dataService: DataService,
    private router: Router,
    private alertService: AlertService,
    private modalService: NgbModal,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {}

  selectCollective(event, modalContent) {
    this.selectedEvent = event;
    let options: NgbModalOptions = {
      windowClass: "modal-collective-opened",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(modalContent, options);

    this.formGroup = new FormGroup({
      numberOfChildren: new FormControl(null, [Validators.required]),
      totalAmount: new FormControl(null, [Validators.required]),
    });
  }

  submitCollectivePayment() {
    if (!this.loading) {
      let postData = _.merge(this.selectedEvent, this.formGroup.getRawValue());

      this.loading = true;
      this.dataService.postEntity("checkout-collective", postData).subscribe(
        (data) => {
          this.loading = false;
          this.successMessage =
            "התשלום בוצע בהצלחה, קבלה מספר " + data.receiptNumber;
        },
        (error) => {
          this.loading = false;
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      );
    }
  }

  completed() {
    this.modalReference.close();
    location.reload();
    //     	this.router.navigate(['/']);
  }

  onChildrenNumberChange() {
    if (
      this.selectedEvent &&
      this.selectedEvent.price &&
      this.formGroup.get("numberOfChildren").valid
    )
      this.formGroup
        .get("totalAmount")
        .patchValue(
          this.formGroup.get("numberOfChildren").value *
            this.selectedEvent.price
        );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/teshlumon/collective-receipt/collective-receipt.component.ts